import React, { useState } from "react";
import {
  Input,
  Button,
  message,
  Form,
  Space,
  Select
} from "antd";
import {
  PlusOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";

import { ClipLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";

import "./style.css";


const AddAPI = () => {
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      // Convert dynamic fields into object
      const extraConfig = {};

      if (values.extra_fields) {
        values.extra_fields.forEach((field) => {
          if (field?.label && field?.value) {
            extraConfig[field.label] = field.value;
          }
        });
      }

      const payload = {
        platform_name: values.platform_name,
        api_key: values.api_key,
        platform_url: values.platform_url,
        status: values.status,
        extra_config: extraConfig,
      };

      message.success("Platform Key saved successfully!");

      form.resetFields();

      navigate("/api-accounts");
    } catch (error) {
      message.error("Failed to create platform key");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/api-accounts");
  };

  if (loading) {
    return (
      <div
        className="loader-container"
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ClipLoader size={50} color={"#123abc"} loading={loading} />
      </div>
    );
  }

  return (
    <div className="api">
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
      >
        <div className="add-api">
          <div className="heading">
            Create New API Account
          </div>

          <div className="api-details">

            {/* Platform Name */}
            <div className="input-group">
              <div className="title">Platform Name</div>

              <Form.Item
                name="platform_name"
                rules={[
                  {
                    required: true,
                    message: "Please enter platform name!",
                  },
                ]}
              >
                <Input placeholder="Enter Platform Name" />
              </Form.Item>
            </div>

            {/* API Key */}
            <div className="input-group">
              <div className="title">API Key / Token</div>

              <Form.Item
                name="api_key"
                rules={[
                  {
                    required: true,
                    message: "Please enter API Key!",
                  },
                ]}
              >
                <Input.Password placeholder="Enter API Key" />
              </Form.Item>
            </div>

            {/* URL */}
            <div className="input-group">
              <div className="title">Endpoint URL</div>

              <Form.Item
                name="platform_url"
                rules={[
                  {
                    required: true,
                    message: "Please enter Endpoint URL!",
                  },
                  {
                    type: "url",
                    message: "Enter a valid URL",
                  },
                ]}
              >
                <Input placeholder="https://example.com/api" />
              </Form.Item>
            </div>

            {/* Status */}
            <div className="input-group">
              <div className="title">Status</div>

              <Form.Item
                name="status"
                initialValue="active"
                rules={[
                  {
                    required: true,
                    message: "Please select status!",
                  },
                ]}
              >
                <Select
                  placeholder="Select Status"
                  options={[
                    {
                      label: "Active",
                      value: "active",
                    },
                    {
                      label: "Inactive",
                      value: "inactive",
                    },
                  ]}
                />
              </Form.Item>
            </div>

          </div>

          {/* Dynamic Fields */}
          <div className="sub-heading">Additional Configurations</div>
          <div className="api-details">
            <Form.List name="extra_fields">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name }) => (
                    <div
                      key={key}
                      className="input-group"
                      style={{ position: "relative" }}
                    >
                      {/* Editable Label */}
                      <Form.Item
                        name={[name, "label"]}
                        rules={[
                          {
                            required: true,
                            message: "Field name required",
                          },
                        ]}
                        style={{ marginBottom: "8px" }}
                      >
                        <Input
                          bordered={false}
                          placeholder="Field Name"
                          className="title"
                        />
                      </Form.Item>

                      {/* Value */}
                      <Form.Item
                        name={[name, "value"]}
                        rules={[
                          {
                            required: true,
                            message: "Field value required",
                          },
                        ]}
                      >
                        <Input.Password placeholder="Enter Value" />
                      </Form.Item>

                      {/* Remove */}
                      <MinusCircleOutlined
                        onClick={() => remove(name)}
                        className="field-remove-icon"
                      />
                    </div>
                  ))}

                  <Button
                    type="dashed"
                    onClick={() => add()}
                    icon={<PlusOutlined />}
                    style={{
                      width: "100%",
                      marginTop: "10px",
                    }}
                  >
                    Add Additional Configuration
                  </Button>
                </>
              )}
            </Form.List>
          </div>
        </div>

        <div className="form-actions">
          <Button onClick={handleCancel}>
            Cancel
          </Button>

          <Button
            className="save-btn"
            type="primary"
            htmlType="submit"
          >
            Save & Connect
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default AddAPI;
